import React from 'react';
import './SimpleImageList.css';

const SimpleImageList = ({ images, projectTitle }) => {
    return (
        <div className="simple-image-list">
            {images.map((src, index) => (
                <div key={index} className="image-item">
                    <img 
                        src={src} 
                        alt={`${projectTitle} ${index + 1}`} 
                        loading="lazy"
                    />
                </div>
            ))}
        </div>
    );
};

export default SimpleImageList;
